import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import colors from 'src/utils/colors';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import ButtonDropdown from '../ButtonDropdown';

export type ActionBarProps = {
  onBack: () => void;
  onNext?: () => void;
  onArchive?: () => void;
  onSave?: (option: { id: string; label: string }) => void;
  hasGeneratedContent: boolean;
  canGoNext: boolean;
  isSaving: boolean;
  getSaveMenuOptions: () => Array<{ id: string; label: string }>;
  canGoBack: boolean;
};

export const ActionBar = ({
  onBack,
  onNext,
  onArchive,
  onSave,
  hasGeneratedContent,
  canGoNext,
  isSaving,
  getSaveMenuOptions,
  canGoBack = true
}: ActionBarProps) => (
  <Flex
    justifyContent="space-between"
    sx={{
      marginTop: '64px'
    }}
  >
    <Flex gap={16}>
      {canGoBack && (
        <SlButton
          buttonSx={{
            border: `1px solid ${colors.graysSecondary}`
          }}
          onClick={(e) => {
            e.preventDefault();
            onBack();
          }}
        >
          Back
        </SlButton>
      )}
    </Flex>
    <Flex gap={16}>
      {hasGeneratedContent && onArchive && (
        <SlButton
          buttonSx={{
            backgroundColor: colors.graysPrimary
          }}
          onClick={onArchive}
          disabled={isSaving}
        >
          Archive content
        </SlButton>
      )}

      {hasGeneratedContent && onSave && (
        <ButtonDropdown
          label="Save content"
          options={getSaveMenuOptions()}
          onChange={onSave}
          variant="contained"
          disabled={isSaving}
        />
      )}
      {canGoNext && onNext && (
        <SlButton
          variant="contained"
          onClick={onNext}
          disabled={isSaving}
          buttonSx={{
            backgroundColor: '#FFFFFF',
            border: `1px solid ${colors.graysSecondary}`,
            '&:hover': {
              backgroundColor: '#F6F7F8',
            }
          }}
          textSx={{
            color: '#031425'
          }}
        >
          Next
        </SlButton>
      )}
    </Flex>
  </Flex>
);
